import { render, staticRenderFns } from "./Awards.vue?vue&type=template&id=1e54ce8d&scoped=true"
import script from "./Awards.vue?vue&type=script&lang=ts"
export * from "./Awards.vue?vue&type=script&lang=ts"
import style0 from "./Awards.vue?vue&type=style&index=0&id=1e54ce8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e54ce8d",
  null
  
)

export default component.exports